import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphabetNumericWithSpecialCharacter]',
})
export class AlphabetNumericWithSpecialCharacterDirective {
  @Input('appAlphabetSpaceOnly') appAlphabetSpaceOnly: boolean = false;
  @Input() regexPattern!: string | RegExp;
  private regex: RegExp = /^[a-zA-Z0-9][a-zA-Z0-9\s.&@]*$/;

  constructor(
    public element: ElementRef,
    private control: NgControl
  ) {}

  ngOnInit(): void {
    // Convert allowedPattern to RegExp
    if (this.regexPattern) {
      try {
        this.regex = new RegExp(this.regexPattern);
      } catch (e) {
        console.error('Invalid regex pattern:', this.regexPattern);
      }
    }
  }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const input = this.element.nativeElement as HTMLInputElement;
    // const regex = /^[a-zA-Z\s]*$/;
    // const regex = /[^a-zA-Z0-9][^a-zA-Z0-9\s.&@/]*$/;
    // const regex = /^[a-zA-Z0-9][a-zA-Z0-9\s.&@]*$/;

    const value = input.value.trimStart();
    if (!this.regex.test(value)) {
      const newValue = !this.regexPattern
        ? value.replace(/[^a-zA-Z0-9\s.&@/]/g, '')
        : value.replace(/\|/g, '');
      this.control.control?.setValue(newValue); //
    }
  }
}
